<template>
  <div>
    <div class="globel-header">
      <a class="left" href="/faq">帮助</a>
      <router-link to="/"><img src="@/assets/logo-white.png" alt=""></router-link>
      <a class="right" v-if="userName === '登录'" href="/login">{{ userName }}</a>
      <a class="right" v-else-if="userName.length <= 4" href="/my">{{ userName }}</a>
      <a class="right" v-else href="/my">{{ userName.slice(0, 4) }}...</a>
    </div>
    <swiper
      containerWidth="100%"
      containerHeight="auto">
      <swiper-slide
        v-for="banner in banners"
        :key="banner.bannerId"
      >
        <a :href="banner.bannerLink">
          <img style="width: 100%;" :src="banner.bannerUrl">
        </a>
      </swiper-slide>
    </swiper>
    <!--div class="row-list" style="margin-top:-11px;">
      <div class="flex-row" style="background-color: #e65f58; ">
          <div style="width: 100%; padding-top: .23rem; padding-bottom: .23rem; z-index: 1000;"><a href="/events" style="color: #fff;"><div style="margin-top: 5px; width: 100%; font-size: .26rem; line-height: .35rem;">
              <div >8/8 丁乃竺的读书会《编剧、导演赖声川》 点击报名！</div>
          </div></a></div>
      </div>
    </div-->
    <div class="row-list" style="margin-top:-11px;" v-if="tickers.length > 0">
      <div class="flex-row" style="background-color: #e65f58; ">
        <div style="width: 100%; padding-top: .23rem; padding-bottom: .23rem; z-index: 1000;"><a v-bind:href="newsLink" style="color: #fff;">
          <div style="margin-top: 5px; width: 100%; font-size: .26rem; line-height: .35rem;">
            <transition name="fade" tag="div" mode="out-in">
              <template v-for="(ticker,idx) in tickers">
                <div class="ticker" v-if="news[idx] && newsUpdate(idx)" :key="idx" >{{ ticker.ticker }}</div>
              </template>
            </transition>
          </div>
        </a></div>
      </div>
    </div>
    <!--div class="row-list" style="margin-top:-11px;">
        <div class="flex-row" style="background-color: #e65f58;">
            <div style="width: 100%; padding-top: .3rem; padding-bottom: .23rem; z-index: 1000;">
                <a href="/event-member" style="color: #fff;">【公告】
                <div style="margin-top: 5px; width: 100%; font-size: .26rem; line-height: .35rem;">6/7-6/9端午假期期间客服专线与微信客服暂停服务<br />
                    《幺幺洞捌》6/11 片段展演发布会开放报名中</div>
            </a>
            </div>
        </div>
    </div-->
    <div class="drama-list">
      <div
        class="drama-item"
        :key="item.id"
        v-for="item in cards"
        @click="gotoPerformDetail(item.id, item.redirect_url)"
      >
        <div
          class="_cover"
          :style="{ 'background-image': `url(${item.coverUrl})` }"
        >
        </div>
        <div class="_content">
          <div class="_title ellipsis-2-line">{{ item.name }}</div>
          <div class="_duration">
            {{ item.duration }}
          </div>
          <div class="_tip">
            <span
              v-for="(tip, index) in item.tips"
              :key="index"
              :class="[tip.color]">
              {{ tip.displayName }}
            </span>
          </div>
          <div class="_price">
            <span>{{ item.priceRange }}</span>
          </div>
          <div v-if="item.description" class="_description ellipsis">
            “{{ item.description }}”
          </div>
        </div>
      </div>
      <div style="text-align: center; color: #aaa; margin-top:15px; margin-bottom: 10px; font-size:0.24rem "><a href="https://beian.miit.gov.cn" target="_blank" style="color:#999">沪ICP备15038853号-1</a> <a href="http://www.beian.gov.cn/portal/registerSystemInfo?spm=a1z09.2.1997523009.39.1a4d2e8ddkIdYI&recordcode=31010402333773" style="color:#999">沪公网安备31010402333773号</a></div>
    </div>
    <footerNav :current="0"></footerNav>
  </div>
</template>

<script>
import {mapState} from 'vuex'
// import { verbs } from '@/utils/request'
import footerNav from '@/components/nav.vue'
import swiper from '@/components/swiper/swiper'
import swiperSlide from '@/components/swiper/swiper-slide'
import PAGES from '@/constants/page'
import router from '@/router'
import store from '@/store'
// import ERRORS from '../constants/errors'
// import API from '../constants/apis'
// import AppError from '@/utils/errors'

export default {
  components: {
    swiper,
    swiperSlide,
    footerNav
  },
  async beforeRouteEnter (to, from, next) {
    const res = await store.dispatch('getHomePage', {})
    if (res.success) {
      to.meta.userId = res.userId
      next()
    } else {
      router.replace({
        name: 'error'
      })
    }
  },
  computed: {
    ...mapState({
      banners: state => state.home.banners,
      cards: state => state.home.cards,
      tickers: state => state.home.tickers,
      userName: state => state.home.userName,
      userId: state => state.home.userId,
    })
  },

  mounted () {
    /*
        verbs['POST'](API.MY_INFO_API, '')
          .then(res => {
            if (res.ok) {
              return res
            } else {
              throw new AppError(ERRORS.NETWORK_ERROR)
            }
          })
          .then((res) => res.json())
          .then((res) => {
            if (!(!res.success && (res.msg === '未登录' || res.msg === '用户已登出'))) {
              this.userName = res.name
            }
          })
          */
  },
  data: function () {
    return {
      tickerLocation: 0,
      news: [
        true,
        false,
      ],
      newsLink: ''
    }
  },
  created: function () {
    for (var i = 0; i < this.tickers.length; i++) {
      this.news[i] = false
    }
    this.news[0] = true
    if (this.tickers.length > 1) {
      setInterval(this.updateTicker, 3000)
    }
  },
  methods: {
    updateTicker: function () {
      var removed = this.news.pop()
      this.news.unshift(removed)
    },
    gotoPerformDetail (performId, redirectUrl) {
      if (!redirectUrl) {
        this.$router.push({
          name: PAGES.PERFORMS,
          params: {performId}
        })
      } else {
        location.href = redirectUrl
      }
    },
    newsUpdate (idx) {
      this.newsLink = this.tickers[idx].link
      if (this.newsLink === '') {
        this.newsLink = '/events'
      }
      return true
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/index.vue